export default __webpack_public_path__ + "static/media/Profile-Active.6543d57b.png";